export default {
  deployments: (state) => state.deployments?.deployments || [],
  allIndices: (state) => state.deployments?.indices || [],
};
